import React, {useState, useEffect} from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material'
import {useIdle} from 'react-use'
import {useLocation} from 'react-router-dom'

const InactivityModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  // Consider the user idle after 5 minutes (300000 milliseconds)
  const isIdle = useIdle(300000)

  useEffect(() => {
    if (isIdle && location.pathname !== '/login') {
      setIsOpen(true)
    }
  }, [isIdle, location.pathname])

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby='inactivity-dialog-title'
      aria-describedby='inactivity-dialog-description'
    >
      <DialogTitle id='inactivity-dialog-title' variant='subtitle1' sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '0.9rem' }}>
        Are you still here ?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='inactivity-dialog-description' sx={{ fontSize: '0.82rem' }}>
          You have been inactive for a while. Do you need more time?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary' sx={{ fontSize: '0.78rem', textTransform: 'none' }}>
          I'm still here
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default InactivityModal
